import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PackagePlus } from 'lucide-react';
import { api } from '../api';
import { Modal } from './ui';

/**
 * NOVÉ PRODUKTY NA SCHVÁLENIE (.580) – vyskakovacie okno pre administrátora.
 * Ukáže sa po otvorení systému, keď Autoimport založil nové (skryté) produkty,
 * ktoré ešte nikto neschválil. „Pripomenúť zajtra" ho schová do konca dňa.
 */
const dnes = () => new Date().toISOString().slice(0, 10);
const KLUC = 'nove_produkty_skryte';

export default function NoveProduktyPripomienka({ user }) {
  const nav = useNavigate();
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (user?.role !== 'admin') return;
    let skryte = null;
    try { skryte = localStorage.getItem(KLUC); } catch { /* bez úložiska */ }
    if (skryte === dnes()) return;
    api.get('/api/autoimport/nove-produkty/pripomienka').then((x) => {
      if (x?.ukazat) { setD(x); setOpen(true); }
    }).catch(() => {});
  }, [user?.id, user?.role]);

  if (!d) return null;
  const zajtra = () => {
    try { localStorage.setItem(KLUC, dnes()); } catch { /* nevadí */ }
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={zajtra} title="Nové produkty v e-shope čakajú na schválenie" size="max-w-xl"
      footer={<>
        <button className="btn-secondary" onClick={zajtra}>Pripomenúť zajtra</button>
        <button className="btn-primary" onClick={() => { setOpen(false); nav('/dielna/nove'); }}>Otvoriť zoznam</button>
      </>}>
      <div className="space-y-3 text-sm">
        <div className="flex gap-3 rounded-xl bg-emerald-50 p-3 text-emerald-900 ring-1 ring-emerald-200">
          <PackagePlus size={22} className="mt-0.5 shrink-0" />
          <div>
            <p>Autoimport založil <b>{d.pocet}</b> {d.pocet === 1 ? 'nový produkt' : d.pocet < 5 ? 'nové produkty' : 'nových produktov'}. Na e-shope sú <b>skryté</b>, kým ich neschválite.</p>
            {d.nejasne > 0 && <p className="mt-1 text-xs text-amber-800">Čaká sa na zaradenie: <b>{d.nejasne}</b> – treba ich zaradiť.</p>}
            {d.podla_spojky?.length > 0 && <p className="mt-1 text-xs text-emerald-800">{d.podla_spojky.map((x) => `${x.s}: ${x.c}`).join(' · ')}</p>}
          </div>
        </div>
        <div className="max-h-[40vh] divide-y divide-slate-100 overflow-auto rounded-xl ring-1 ring-slate-200">
          {d.najnovsie.map((x) => (
            <div key={x.kod} className="px-3 py-2">
              <div className="font-medium text-slate-800">{x.nazov || x.kod}</div>
              <div className="text-xs text-slate-500">
                {x.kod} · {x.spojka || '—'}{x.nejasna ? ' · bez kategórie' : ''}{x.druh === 'stroj' ? ' · stroj – dlaždice' : ''}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
}
